<template>
  <div class="admin-content">
    <div class="content-main">
      <div class="main-header">
        <div class="header-title">
          <span>LANDING PAGE INSTANCE</span>
        </div>
      </div>
      <div class="">
        <div class="">
          <el-select
            v-model="instanceId" filterable remote placeholder="Select"
            :remote-method="getInstances" :loading="flagLoading.getInstances" @change="selectInstance"
          >
            <el-option v-for="(item) in instances" :key="item._id" :value="item._id" :label="item.general.name"></el-option>
          </el-select>
        </div>
        <div class="infos-actions">
          <el-button size="small" class="el-btn-blue" @click="updateLanding" :loading="flagLoading.updateLanding">SAVE CHANGES</el-button>
          <el-button size="small" @click="returnBack">CANCEL</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive } from 'vue'
import _ from 'lodash'
export default {
  name: 'GlobalLanding',
  components: {
  },
  data () {
    const flagLoading = reactive({
      getInstances: false,
      updateLanding: false
    })
    return {
      instances: [],
      instanceId: '',
      instance: {},
      flagLoading
    }
  },
  created () {
    this.getLanding()
    this.getInstances('')
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getLanding: function () {
      const url = '/api/v1/atk_player/admin/settings/landing_instance'
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.instance = res.data.content.instance || {}
          that.instanceId = that.instance._id
        } else {
          console.error('getLanding', res.msg)
        }
      }).catch(function (err) {
        console.error('getLanding', err.msg)
      })
    },
    getInstances: function (query) {
      this.flagLoading.getInstances = true
      const url = `/api/v1/atk_player/admin/instances?page_num=1&page_size=20&is_deleted=false&name=${query}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.instances = res.data.list
        } else {
          console.error('getInstances', res.msg)
        }
        that.flagLoading.getInstances = false
      }).catch(function (err) {
        that.flagLoading.getInstances = false
        console.error('getInstances', err)
      })
    },
    updateLanding: function () {
      if (this.flagLoading.updateLanding) return
      this.flagLoading.updateLanding = true
      const url = '/api/v1/atk_player/admin/settings/landing_instance'
      const body = { content: { instance: { ...this.instance } } }
      const that = this
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          console.error('updateLanding', res.msg)
        }
        that.flagLoading.updateLanding = false
      }).catch(function (err) {
        console.error('updateLanding', err.msg)
        that.flagLoading.updateLanding = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    selectInstance: function (val) {
      const instanceIndex = _.findIndex(this.instances, { _id: val })
      if (instanceIndex >= 0) this.instance = this.instances[instanceIndex]
    }
  }
}
</script>

<style scoped lang="scss">
.infos-actions {
  margin-top: 30px;
}
</style>
